/**
 * 青山科技奖头部组件
 */
import React from 'react';
import './AwardHeader.scss';
import { APPLY_YEAR } from '../../utils/config';

const AwardHeader = () => {
  return (
    <div className="award-header-common">
      <video src="https://s3plus.meituan.net/v1/mss_4662117880a641b09d8a16636fb73609/greentech-public/blueBanner.mp4" muted autoPlay loop className="video-class"></video>
      <div className="header-content">
        <span className="title">青山科技奖</span>
        <div className="content">青山科技奖聚焦绿色、低碳、可持续发展。{APPLY_YEAR}年度，奖项主要关注绿色低碳材料、碳捕集及资源化利用、新能源及储能、降碳减污协同控制四大议题， 资助在材料科学、化学、化学工程、环境科学、能源科学等学科领域，有关键推动作用的青年科研工作者。</div>
      </div>
    </div>
  );
};

export default AwardHeader;
